import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';
import PropTypes from 'prop-types';
import { Stack, Typography, Box, TextField, Dialog, DialogContent } from '@mui/material';
import axiosInstance from '../../utils/axios';
import { objectToFormData } from '../../utils/objectToFormData';
import EditRoles from './EditRoles';
import updateItemInPlaceOrAppend from '../../utils/updateItemInPlaceOrAppend';

UserEditForm.propTypes = {
  editUser: PropTypes.object,
  setUsers: PropTypes.func,
  open: PropTypes.bool,
  close: PropTypes.func
}

export default function UserEditForm({ open, close, editUser, setUsers })
{
  const { enqueueSnackbar } = useSnackbar();

  const [submitting, setSubmitting] = useState(false);
  const [submitSuccessUserId, setSubmitSuccessUserId] = useState(null);
  const [formValue, setFormValue] = useState({});

  useEffect(() => {
    setFormValue({
      id: editUser?.id,
      firstName: editUser?.firstName ?? "",
      lastName: editUser?.lastName ?? "",
      email: editUser?.email ?? "",
      password: ""
    });
  }, [editUser, open])

  const onSubmit = () => {
    setSubmitting(true);
    axiosInstance.post(editUser ? "/user/edituser" : "/user/newuser", objectToFormData(formValue))
      .then((res) => {
        if (res.data.user) {
          enqueueSnackbar(editUser ? 'User updated ' : "User created", { variant: 'success' });
          setUsers(users => updateItemInPlaceOrAppend(users, res.data.user));
          setSubmitSuccessUserId(res.data.user.id);
        }
        else enqueueSnackbar(res.data.error ?? `${(editUser ? "Update" : "Create")} user failed`, { variant: 'error' })
      })
      .catch(() => enqueueSnackbar(`${(editUser ? "Update" : "Create")} user failed`, { variant: 'error' }))
      .finally(() => setSubmitting(false));
  };

  return <Dialog open={open} onClose={close} maxWidth="md" >
    <DialogContent>
      <Stack spacing={1} minWidth="600px">
        <Box>
          <Typography>First Name*</Typography>
          <TextField
            name="firstName"
            size="small"
            placeholder="Enter First Name"
            fullWidth
            value={formValue.firstName}
            onChange={(e) => setFormValue(form => ({ ...form, firstName: e.target.value }))}
          />
        </Box>
        <Box>
          <Typography>Last Name*</Typography>
          <TextField
            name="lastName"
            size="small"
            placeholder="Enter Last Name"
            fullWidth
            value={formValue.lastName}
            onChange={(e) => setFormValue(form => ({ ...form, lastName: e.target.value }))}
          />
        </Box>
        <Box>
          <Typography>Email*</Typography>
          <TextField
            name="email"
            size="small"
            placeholder="Enter Contact Email"
            fullWidth
            value={formValue.email}
            onChange={(e) => setFormValue(form => ({ ...form, email: e.target.value }))}
          />
        </Box>
        <Box>
          <Typography>{editUser ? "Reset " : ""}Password</Typography>
          <TextField
            name="password"
            size="small"
            placeholder="Enter Password"
            fullWidth
            value={formValue.password}
            onChange={(e) => setFormValue(form => ({ ...form, password: e.target.value }))}
          />
        </Box>       
        <Box>
          <LoadingButton loading={submitting} sx={{ display: "flex", justifySelf: "center", mb: 2, px: 7 }} color="purple" size="medium" variant="contained"
            onClick={onSubmit} disabled={!formValue.email || !formValue.firstName || !formValue.lastName}>
            Save
          </LoadingButton>
        </Box>
      </Stack>
      {submitSuccessUserId  && <EditRoles open={submitSuccessUserId != null} close={() => { close(); setSubmitSuccessUserId(null); }} userId={submitSuccessUserId} />} 
    </DialogContent>
  </Dialog>;
}
